import {React, useState} from 'react';
import {Grid, Box, Button, Paper, Stack,Typography} from '@mui/material';
import {Add} from '@mui/icons-material';
import { GiModernCity } from "react-icons/gi";
import '../../App.css'
import CompanyDefinitionForm from './CompanyDefinitionForm';
import CompanyMasterTable from '../table-data/CompanyMasterTable';
import Popup from '../Popup';

function ViewCompanies(){

const [openPopup, setOpenPopup] = useState(false);
  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })
 const handleCloseModal = () => {
    setOpenPopup(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  }

  return(
    <Box sx={{display: "flex" ,justifyContent: "center",marginTop: "-30px", margin: "10px", padding: "30px", fontWeight: "500px"}}>
      <Paper elevation={0} sx={{width: "1500px"}}>
        <Grid className="form-title" style={{marginBottom: "-60px"}} container spacing={2}>
          <Grid item> <Typography variant="h5" color="#344D67"sx={{textAlign: "center", margin: 5, textDecoration: "underline"}}>Companies</Typography> </Grid>
          <Grid item> <GiModernCity style={{marginLeft: "-30px"}} size="40px" color="#344D67"/> </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={handleSubmit}>
            <Stack spacing={2} sx={{margin: "30px"}}>

            <CompanyMasterTable/>




            </Stack>
        </form>

        <Popup
          title="Add a Company"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <CompanyDefinitionForm fetch_id={9999} onCloseModal={handleCloseModal} />
          {/*<CompanyModifyOptions title="Add a Company" fetch_id={9999}/>
          <EmployeeSalaryForm/>
          <LeaveDataMaster/>*/}
        </Popup>

      </Paper>
    </Box>
  )
}

export default ViewCompanies;
